<template>
  <div style="height: 95%;margin-top: 2%; overflow-x: hidden;overflow-y: auto;">
    <!-- <h1 style="text-align: center; ">会展策划</h1> -->
    <div class="box">
      <div class="exhibitionbox">
        <h2>会展行业</h2>
        <dv-border-box-2 class="box10">
          <!-- <div id="chart-container1" class="chart-container">

                              </div> -->
          <section class="cloud-bed">
            <div class="cloud-box1">
              <span v-for="(item, index) in ExhibitionIndustryList"
                    :key="index"
                    @click="getDataindustry(item)"
                    :style="industrySelectedList.filter(c=>c==item.id).length>0?{color:'#4269f5',background:'rgb(57, 193, 207,0.12)'}:{color:'#303C42',background:'rgb(57, 193, 207,0.12)'}">
                {{ item.name }}
              </span>
            </div>
          </section>
        </dv-border-box-2>
      </div>
      <div class="exhibitionbox">
        <h2>目标市场</h2>
        <dv-border-box-2 class="box10">
          <!-- <div id="chart-container2" class="chart-container">

                              </div> -->
          <section class="cloud-bed">
            <div class="cloud-box2">
              <span v-for="(item, index) in TargetMarketList"
                    :key="index"
                    @click="getDatamarket(item)"
                    :style="targetSelectedList.filter(c=>c==item.id).length>0?{color:'#4269f5',background:'rgb(57, 193, 207,0.12)'}:{color:'#303C42',background:'rgb(57, 193, 207,0.12)'}">
                {{ item.name }}
              </span>
            </div>
          </section>
        </dv-border-box-2>
      </div>
    </div>
    <div class="box">
      <div class="exhibitionbox1">
        <el-form :model="planForm"
                 ref="planForm"
                 :rules="rules"
                 label-width="120px">
          <el-form-item label="会展地址:"
                        prop="addressId">
            <el-select size="medium"
                       v-model="planForm.addressId"
                       :disabled="isdisabled"
                       class="inputs">
              <el-option v-for="item in AreaList"
                         @click="selectArea(item.id)"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会展行业:"
                        :required="true"
                        prop="industry">
            <el-input v-model="planForm.industry"
                      disabled="true"
                      class="inputs"
                      type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="目标市场:"
                        :required="true"
                        prop="market">
            <el-input v-model="planForm.market"
                      disabled="true"
                      class="inputs"
                      type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="会展场地:"
                        :required="true"
                        prop="site">
            <el-input v-model="planForm.site"
                      disabled="true"
                      class="inputs"></el-input>
          </el-form-item>
          <el-form-item label="会展需求:"
                        :required="true"
                        prop="demand">
            <el-input v-model="planForm.demand"
                      disabled="true"
                      class="inputs"
                      type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="会展的主题:"
                        :required="theme"
                        prop="theme">
            <el-input v-model="planForm.theme"
                      :disabled="isdisabled"
                      class="inputs"></el-input>
          </el-form-item>
          <!-- <el-form-item label="会展的数量:" :required="number" prop="number">
                        <el-input v-model="planForm.number" :disabled="isdisabled" class="inputs" oninput="value=value.replace(/[^\d]/g, '').length>9?value.replace(/[^\d]/g, '').substring(0,9):value.replace(/[^\d]/g, '')"
              maxlength="9"></el-input>
               </el-form-item>
             -->
          <el-tooltip :content="CaseList.length>0?CaseList[0].largeBoothArea + '㎡' : '' "
                      placement="bottom"
                      effect="light">
            <el-form-item label="大展位数量:"
                          :required="largeBoothArea"
                          prop="largeBoothArea">
              <el-input v-model="planForm.largeBoothArea"
                        v-on:input="largeBootClick"
                        :disabled="isdisabled"
                        class="inputs"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                        @input="inputChange"
                        maxlength="9">
                <template #append>个</template>
              </el-input>
              <!-- <label>{{CaseList.length>0?CaseList[0].largeBoothArea:""}}㎡</label> -->
            </el-form-item>
          </el-tooltip>
          <el-tooltip :content="CaseList.length>0?CaseList[0].mediumBoothArea + '㎡' : '' "
                      placement="bottom"
                      effect="light">
            <el-form-item label="中展位数量:"
                          :required="mediumBoothArea"
                          prop="mediumBoothArea">
              <el-input v-model="planForm.mediumBoothArea"
                        v-on:input="largeBootClick"
                        :disabled="isdisabled"
                        class="inputs"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                        @input="inputChange"
                        maxlength="9">
                <template #append>个</template>
              </el-input>
              <!-- <label>{{CaseList.length>0?CaseList[0].mediumBoothArea:""}}㎡</label> -->
            </el-form-item>
          </el-tooltip>
          <el-tooltip :content="CaseList.length>0?CaseList[0].smallBoothArea + '㎡' : '' "
                      placement="bottom"
                      effect="light">
            <el-form-item label="小展位数量:"
                          :required="smallBoothArea"
                          prop="smallBoothArea">
              <el-input v-model="planForm.smallBoothArea"
                        v-on:input="largeBootClick"
                        :disabled="isdisabled"
                        class="inputs"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                        @input="inputChange"
                        maxlength="9">
                <template #append>个</template>
              </el-input>
              <!-- <label>{{CaseList.length>0?CaseList[0].smallBoothArea:""}}㎡</label> -->
            </el-form-item>
          </el-tooltip>
          <el-form-item label="正餐数量:"
                        :required="dinnerNumber"
                        prop="dinnerNumber">
            <el-input v-model="planForm.dinnerNumber"
                      v-on:input="largeBootClick"
                      :disabled="isdisabled"
                      class="inputs"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                      @input="inputChange"
                      maxlength="9">
              <template #append>桌</template>
            </el-input>
          </el-form-item>
          <el-form-item label="茶点数量:"
                        :required="teaNumber"
                        prop="teaNumber">
            <el-input v-model="planForm.teaNumber"
                      v-on:input="largeBootClick"
                      :disabled="isdisabled"
                      class="inputs"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                      @input="inputChange"
                      maxlength="9">
              <template #append>位</template>
            </el-input>
          </el-form-item>
          <div style="text-align: center;margin-bottom: 20px;">
            <label>会展场地面积：<span style="color:red">{{SiteArea}}</span>㎡</label>
            <label>已选面积：<span style="color:red">{{SelectArea}}</span>㎡</label>
          </div>
          <el-form-item label="开始日期:"
                        :required="starData"
                        prop="starData">
            <el-date-picker :disabled="isdisabled"
                            @change="SelectDate"
                            v-model="planForm.starData"
                            type="date"
                            :size="size"
                            format="YYYY/MM/DD"
                            value-format="YYYY-MM-DD"
                            :disabled-date="pickerOptions" />
          </el-form-item>
          <el-form-item label="结束日期:"
                        prop="endData">
            <el-date-picker disabled="true"
                            v-model="planForm.endData"
                            type="date"
                            :size="size"
                            format="YYYY/MM/DD"
                            value-format="YYYY-MM-DD" />
          </el-form-item>

          <el-form-item prop="isactivity">
            <el-checkbox v-model="planForm.isactivity"
                         :disabled="isdisabled">是否开展小活动</el-checkbox>
          </el-form-item>
          <div v-if="planForm.isactivity==true">
            <!-- <el-form-item label="活动次数:" prop="activityCount">
                          <el-input v-model="planForm.activityCount" class="inputs" :disabled="isdisabled" oninput="value=value.replace(/[^\d]/g, '').length>9?value.replace(/[^\d]/g, '').substring(0,9):value.replace(/[^\d]/g, '')"
              maxlength="9" ></el-input>
                        </el-form-item> -->
            <el-form-item label="活动数量:"
                          prop="activityNumber">
              <el-input v-model="planForm.activityNumber"
                        class="inputs"
                        :disabled="isdisabled"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                        @input="inputChange"
                        maxlength="9"></el-input>
            </el-form-item>
            <el-form-item label="活动类型:"
                          prop="activityID">
              <el-select size="medium"
                         v-model="planForm.activityID"
                         class="inputs"
                         :disabled="isdisabled">
                <el-option v-for="item in ActivityList"
                           @click="selectType(item.id)"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary"
                       @click="onsubmit()">{{
                      SModelExhibitionPlanning.filter(
                                                                (t) =>
                                                                  t.state != Global.SModel.Delete
                                                              ).length > 0
                                                                ? "取消"
                                                                : "确定"
                                                            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="box">
      <div class="exhibitionbox">
        <h2>会展场地</h2>
        <dv-border-box-2 class="box10">
          <section class="cloud-bed">
            <div class="cloud-box3">
              <span v-for="(item, index) in ExhibitionVenueList"
                    :key="index"
                    @click="getDatasite(item)"
                    :style="venueSelectedList==item.id?{color:'#4269f5',background:'rgb(57, 193, 207,0.12)'}:{color:'#303C42',background:'rgb(57, 193, 207,0.12)'}">
                {{ item.name }}
              </span>
            </div>
          </section>
        </dv-border-box-2>
      </div>
      <div class="exhibitionbox">
        <h2>会展需求</h2>
        <dv-border-box-2 class="box10">
          <section class="cloud-bed">
            <div class="cloud-box4">
              <span v-for="(item, index) in ExhibitionDemandList"
                    :key="index"
                    @click="getDatademand(item)"
                    :style="demandSelectedList.filter(c=>c==item.id).length>0?{color:'#4269f5',background:'rgb(57, 193, 207,0.12)'}:{color:'#303C42',background:'rgb(57, 193, 207,0.12)'}">
                {{ item.name }}
              </span>
            </div>
          </section>
        </dv-border-box-2>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
//import * as echarts from "echarts";
import "echarts-wordcloud";
import { nextTick } from 'vue';
//import bus from '../../../unit/bus';
export default {
  data () {
    return {
      caseID: localStorage.getItem("caseId"),
      flowID: localStorage.getItem("flowID"),
      ExhibitionIndustryList: [],
      ExhibitionVenueList: [],
      TargetMarketList: [],
      ExhibitionDemandList: [],
      SModelExhibitionPlanning: [],
      activityTypeList: [{ name: '教育活动', id: 1 }, { name: '公益活动', id: 2 }, { name: '文娱活动', id: 3 }],
      AreaList: [],
      Area: null,
      CaseList: [],
      ActivityList: [],
      MarketReport: {},
      isdisabled: false,
      SelectArea: 0,
      SiteArea: 0,
      industrySelectedList: [],
      targetSelectedList: [],
      venueSelectedList: 0,
      demandSelectedList: [],
      planForm: {
        industry: "",
        market: "",
        site: "",
        theme: "",
        largeBoothArea: '',
        mediumBoothArea: '',
        smallBoothArea: '',
        demand: "",
        industryIds: '',
        marketIds: null,
        siteId: null,
        demandId: null,
        round: null,
        uuid: null,
        sTTime: null,
        type: '',
        state: null,
        isactivity: false,
        activityID: null,
        starData: new Date('YYYY/MM/DD'),
        endData: '',
        activityNumber: 1,
        dinnerNumber: '',
        teaNumber: '',
        addressId: 6
      },
      rules: {
        industry: [{ required: true, message: "请选择会展行业", trigger: "blur" },],
        market: [{ required: true, message: "请选择目标市场", trigger: "blur" }],
        site: [{ required: true, message: "请选择会展场地", trigger: "blur" }],
        mediumBoothArea: [{ required: true, message: "请输入中展位数量", trigger: "blur" }],
        largeBoothArea: [{ required: true, message: "请输入大展位数量", trigger: "blur" }],
        smallBoothArea: [{ required: true, message: "请输入小展位数量", trigger: "blur" }],
        theme: [{ required: true, message: "请输入会展的主题", trigger: "blur" }],
        demand: [{ required: true, message: "请选择会展需求", trigger: "blur" }],
        starData: [{ required: true, message: "请选择开始日期", trigger: "blur" },{ type: 'date', message: '请输入正确格式的日期', trigger: ['change'] }],
        dinnerNumber: [{ required: true, message: "请输入正餐数量", trigger: "blur" }],
        teaNumber: [{ required: true, message: "请输入茶点数量", trigger: "blur" }],
      },
      timer: 50, // 球体转动速率
      dtr: Math.PI / 180, //鼠标滑过球体转动速度

      lasta: 0, // 上下转动
      lastb: 0.5, // 左右转动
      distr: true,
      tspeed: 0, // 鼠标移动上去时球体转动
      mouseX: 0,
      mouseY: 0,
      tagAttrList: [],
      tagContent: null,
      cloudContent: null,
      radius: 0, // 词云球体面积大小
      active: false, // 默认加载是否开启转动

      tagAttrList1: [],
      tagContent1: null,
      cloudContent1: null,
      radius1: 0, // 词云球体面积大小
      active1: false, // 默认加载是否开启转动

      tagAttrList2: [],
      tagContent2: null,
      cloudContent2: null,
      radius2: 0, // 词云球体面积大小
      active2: false, // 默认加载是否开启转动
      timer2: 0,

      tagAttrList3: [],
      tagContent3: null,
      cloudContent3: null,
      radius3: 0, // 词云球体面积大小
      active3: false, // 默认加载是否开启转动
      sinA: '',
      cosA: '',
      sinB: '',
      cosB: '',
      sinC: '',
      cosC: '',
    };
  },
  components: {},
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      Planning: (state) => state.user.planning,
      TaskBar: (state) => state.user.taskBar,
    }),
  },
  created () {
  },
  mounted () {
    //this.infoChart();
    this.infoChart();
    this.GetCaseList();
    this.GetActivityList();
    this.GetMarketReport();
    this.$nextTick(() => {
      this.radius = document.querySelector('.cloud-box1').offsetWidth / 2
      this.radius1 = document.querySelector('.cloud-box2').offsetWidth / 2
      this.radius2 = document.querySelector('.cloud-box3').offsetWidth / 2
      this.radius3 = document.querySelector('.cloud-box4').offsetWidth / 2
    })
  },
  beforeUnmount () {
    clearInterval(this.timer)
  },
  methods: {
    pickerOptions (time) {
      return time.getTime() < new Date().getTime() - 8.64e7
    },
    inputChange (val) {
      console.log(val);
      this.planForm.largeBoothArea = this.planForm.largeBoothArea.toString().replace(/[^0-9.]/g, '')
      this.planForm.mediumBoothArea = this.planForm.mediumBoothArea.toString().replace(/[^0-9.]/g, '')
      this.planForm.smallBoothArea = this.planForm.smallBoothArea.toString().replace(/[^0-9.]/g, '')
      this.planForm.dinnerNumber = this.planForm.dinnerNumber.toString().replace(/[^0-9.]/g, '')
      this.planForm.teaNumber = this.planForm.teaNumber.toString().replace(/[^0-9.]/g, '')
      this.planForm.activityNumber = this.planForm.activityNumber.toString().replace(/[^0-9.]/g, '')
    },
    SelectDate (o) {
      let date = new Date(o);
      date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      date = Date.parse(new Date(date)) / 1000; // 转换成时间戳，返回值是ms，除1000后转化成秒
      date += (86400) * this.MarketReport.exhibitionDays; // 一天是86400秒
      let newDate = new Date(parseInt(date) * 1000); // 把时间戳转换成日期
      this.planForm.endData = newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, 0) + '-' + newDate.getDate().toString().padStart(2, 0);
    },
    largeBootClick () {
      var cases = this.CaseList[0];
      let largeBoothArea = 0;
      if (this.planForm.largeBoothArea != null) {
        largeBoothArea = this.planForm.largeBoothArea
      }
      let mediumBoothArea = 0;
      if (this.planForm.mediumBoothArea != null) {
        mediumBoothArea = this.planForm.mediumBoothArea
      }
      let smallBoothArea = 0;
      if (this.planForm.smallBoothArea != null) {
        smallBoothArea = this.planForm.smallBoothArea
      }
      this.SelectArea = largeBoothArea * cases.largeBoothArea + mediumBoothArea * cases.mediumBoothArea + smallBoothArea * cases.smallBoothArea;
    },
    selectArea (id) {
      this.$http.get('ExhibitionVenue/GetAllExhibitionVenue?areaID=' + id).then((res) => {
        if (res.success) {
          this.ExhibitionVenueList = res.dynamicObj
          this.tagAttrList2 = [];
          this.tagContent2 = null;
          this.cloudContent2 = null;
          this.sinA = '';
          this.cosA = '';
          this.sinB = '';
          this.cosB = '';
          this.sinC = '';
          this.cosC = '';
          this.mouseX = 0;
          this.mouseY = 0;
          clearInterval(this.timer2);
          this.active2 = false, // 默认加载是否开启转动
            nextTick(() => {
              this.initWordCloudsite();
            });
        }
      })
    },
    GetMarketReport () {
      this.$http
        .get(
          "MarketReport/GetMarketReport?caseID=" + this.caseID
        )
        .then((res) => {
          if (res.success) {
            this.MarketReport = res.dynamicObj;
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetCaseList () {
      this.$http
        .get(
          "Case/GetModels?id=" + this.caseID
        )
        .then((res) => {
          if (res.success) {
            this.CaseList = res.dynamicObj;
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetActivityList () {
      this.$http
        .get(
          "Activity/GetModel"
        )
        .then((res) => {
          if (res.success) {
            this.ActivityList = res.dynamicObj;
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetAreaList () {
      this.$http
        .get(
          "Area/GetArea?pageNumber=1&pageSize=999"
        )
        .then((res) => {
          if (res.success) {
            this.AreaList = res.dynamicObj;
            if (this.AreaList.length > 0) {
              this.planForm.addressId = this.AreaList[0].id;
            }
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetSModelExhibitionPlanning () {
      this.$http
        .get(
          "SModel/GetTypeSModel?round=" +
          this.Round +
          "&typename=S_ExhibitionPlanning"
        )
        .then((res) => {
          if (res.success) {
            this.SModelExhibitionPlanning = res.dynamicObj;
            if (this.SModelExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete).length > 0) {
              this.isdisabled = true;
              this.planForm = this.SModelExhibitionPlanning[0];
              this.selectArea(this.planForm.addressId)
              this.industrySelectedList = this.planForm.industryIds.split(',');
              this.targetSelectedList = this.planForm.marketIds.split(',');
              this.venueSelectedList = this.planForm.siteId;
              this.demandSelectedList = this.planForm.demandId.split(',');
              this.SelectArea = this.SModelExhibitionPlanning[0].selectArea;
              this.SiteArea = this.SModelExhibitionPlanning[0].siteArea;
            } else {
              this.GetAreaList();
              this.isdisabled = false;
            }
            //this.AreaList = res.dynamicObj;

          } else {
            return this.$message.error(res.message);
          }
        });
    },
    onsubmit () {
      if (this.flowID != this.Global.FlowList.策划) {
        this.$message.error("当前流程阶段不是策划，无法进行操作！");
        return;
      }
      let that = this;
      that.$refs.planForm.validate((valid) => {
        if (valid) {
          let list = that.SModelExhibitionPlanning;
          if (list.filter(c => c.state != that.Global.SModel.Delete).length > 0) {
            list[0].state = that.Global.SModel.Delete;
            that.$http
              .post("SModel/PushStrategy", that.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  that.Global.sendmsgmd(
                    "项目管理",
                    `取消了会展策划`,
                    1
                  );
                  that.GetSModelExhibitionPlanning();
                  that.$store.commit("exhibitionPlanning", !this.Planning);
                  that.API.createTaskBar(that.Round, that.Global.EnumUserStatus.delete, '会展策划');
                } else {
                  that.$message.error(res.message);
                  return false;
                }
              });

          } else {
            if (this.SelectArea > this.SiteArea) {
              this.$message.warning("已选场地面积不能大于会展场地面积");
              return;
            }
            list = that.SModelExhibitionPlanning;
            if (list.length == 0) {
              list = [];
              list.push(that.planForm)
              list[0].uuid = that.uuid.guid();
              list[0].state = that.Global.SModel.Create;
            } else {
              let uuid = list[0].uuid;
              list = [];
              list.push(that.planForm)
              list[0].state = that.Global.SModel.Update;
              list[0].uuid = uuid;
            }
            if (that.planForm.isactivity == true) {
              if (that.planForm.activityNumber == null || that.planForm.activityNumber == 0) {
                this.$message.error('请输入活动数量,并且不能小于0条');
                return;
              }
              if (that.planForm.activityID == null) {
                this.$message.error('请选择活动类型');
                return;
              }
            }
            list[0].round = that.Round;
            list[0].type = "S_ExhibitionPlanning";
            list[0].sTTime = that.filter.formatDate(new Date());
            list[0].siteArea = this.SiteArea;
            list[0].selectArea = this.SelectArea;
            let myDate_1 = Date.parse(this.planForm.starData)
            let myDate_2 = Date.parse(this.planForm.endData)
            var diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值
            var totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
            list[0].days = totalDays;

            that.$http
              .post("SModel/PushStrategy", that.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  that.Global.sendmsgmd(
                    "项目管理",
                    `添加了会展策划`,
                    1
                  );
                  that.GetSModelExhibitionPlanning();
                  that.$store.commit("exhibitionPlanning", !this.Planning);
                  that.API.createTaskBar(that.Round, that.Global.EnumUserStatus.normal, '会展策划');
                } else {
                  that.$message.error(res.message);
                  return false;
                }
              });
          }

        }
      });

    },
    infoChart () {
      this.$http.get('ExhibitionIndustry/GetModel').then((res) => {
        if (res.success) {
          this.ExhibitionIndustryList = res.dynamicObj
          nextTick(() => {
            this.initWordCloudindustry();
          });
          this.$http.get('TargetMarket/GetModel').then((res1) => {
            if (res1.success) {
              this.TargetMarketList = res1.dynamicObj
              nextTick(() => {
                this.initWordCloudmarket();
              });
              this.$http
                .get(
                  "Area/GetArea?pageNumber=1&pageSize=999"
                )
                .then((res) => {
                  if (res.success) {
                    this.AreaList = res.dynamicObj;
                    if (this.AreaList.length > 0) {
                      this.planForm.addressId = this.AreaList[0].id;
                      this.selectArea(this.planForm.addressId);
                      this.$http.get('ExhibitionDemand/GetModel').then((res) => {
                        if (res.success) {
                          this.ExhibitionDemandList = res.dynamicObj
                          nextTick(() => {
                            this.GetSModelExhibitionPlanning();
                            this.initWordClouddemand();
                          });
                        }
                      })
                    }
                  } else {
                    return this.$message.error(res.message);
                  }
                });

              // this.$http.get('ExhibitionVenue/GetModel').then((res)=>{
              //   if(res.success){
              //     this.ExhibitionVenueList=res.dynamicObj
              //     nextTick(()=>{
              //       this.initWordCloudsite();
              //     });

              //   }
              // })   
            }
          })
        }
      })
    },
    // 获取点击文本信息
    getDataindustry (item) {
      if (this.SModelExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete).length == 0) {
        if (this.industrySelectedList.filter(c => c == item.id).length == 0) {
          this.industrySelectedList.push(item.id);
          this.planForm.industry += "," + item.name;
          this.planForm.industryIds += "," + item.id;
          if (this.industrySelectedList.length == 1) {
            this.planForm.industry = this.planForm.industry.substring(1, this.planForm.industry.length);
            this.planForm.industryIds = this.planForm.industryIds.substring(1, this.planForm.industryIds.length);
          }

        } else {
          this.industrySelectedList = this.industrySelectedList.filter(c => c !== item.id);
          this.planForm.industry = this.planForm.industry.split(',').filter(c => c != item.name).join(',');
          this.planForm.industryIds = this.planForm.industryIds.split(',').filter(c => c != item.id).join(',');
        }
      }
    },
    initWordCloudindustry () {
      this.cloudContent = document.querySelector('.cloud-box1');
      this.tagContent = this.cloudContent.getElementsByTagName('span');
      for (let i = 0; i < this.tagContent.length; i++) {
        let tagObj = {};
        tagObj.offsetWidth = this.tagContent[i].offsetWidth;
        tagObj.offsetHeight = this.tagContent[i].offsetHeight;
        this.tagAttrList.push(tagObj);
      }
      this.sineCosine(0, 0, 0);
      this.positionAllindustry();
      this.cloudContent.onmouseover = () => {
        this.active = true;
      };
      this.cloudContent.onmouseout = () => {
        this.active = false;
      };
      this.cloudContent.onmousemove = (ev) => {
        let oEvent = window.event || ev;
        this.mouseX = oEvent.clientX - (this.cloudContent.offsetLeft + this.cloudContent.offsetWidth / 2);
        this.mouseY = oEvent.clientY - (this.cloudContent.offsetTop + this.cloudContent.offsetHeight / 2);
        this.mouseX /= 5;
        this.mouseY /= 5;
      };
      setInterval(this.updateindustry, this.timer);
    },
    positionAllindustry () {
      let phi = 0;
      let theta = 0;
      let max = this.tagAttrList.length;
      let aTmp = [];
      let oFragment = document.createDocumentFragment();
      //随机排序
      for (let i = 0; i < this.tagContent.length; i++) {
        aTmp.push(this.tagContent[i]);
      }
      aTmp.sort(() => {
        return Math.random() < 0.5 ? 1 : -1;
      });
      for (let i = 0; i < aTmp.length; i++) {
        oFragment.appendChild(aTmp[i]);
      }
      this.cloudContent.appendChild(oFragment);
      for (let i = 1; i < max + 1; i++) {
        if (this.distr) {
          phi = Math.acos(-1 + (2 * i - 1) / max);
          theta = Math.sqrt(max * Math.PI) * phi;
        } else {
          phi = Math.random() * (Math.PI);
          theta = Math.random() * (2 * Math.PI);
        }
        //坐标变换
        this.tagAttrList[i - 1].cx = this.radius * Math.cos(theta) * Math.sin(phi);
        this.tagAttrList[i - 1].cy = this.radius * Math.sin(theta) * Math.sin(phi);
        this.tagAttrList[i - 1].cz = this.radius * Math.cos(phi);
        this.tagContent[i - 1].style.left = this.tagAttrList[i - 1].cx + this.cloudContent.offsetWidth / 2 - this.tagAttrList[i - 1].offsetWidth / 2 + 'px';
        this.tagContent[i - 1].style.top = this.tagAttrList[i - 1].cy + this.cloudContent.offsetHeight / 2 - this.tagAttrList[i - 1].offsetHeight / 2 + 'px';
      }
    },
    updateindustry () {
      let angleBasicA;
      let angleBasicB;
      if (this.active) {
        angleBasicA = (-Math.min(Math.max(-this.mouseY, -200), 200) / this.radius) * this.tspeed;
        angleBasicB = (Math.min(Math.max(-this.mouseX, -200), 200) / this.radius) * this.tspeed;
      } else {
        angleBasicA = this.lasta * 0.98;
        angleBasicB = this.lastb * 0.98;
      }
      this.sineCosine(angleBasicA, angleBasicB, 0);
      for (let j = 0; j < this.tagAttrList.length; j++) {
        let rx1 = this.tagAttrList[j].cx;
        let ry1 = this.tagAttrList[j].cy * this.cosA + this.tagAttrList[j].cz * (-this.sinA);
        let rz1 = this.tagAttrList[j].cy * this.sinA + this.tagAttrList[j].cz * this.cosA;
        let rx2 = rx1 * this.cosB + rz1 * this.sinB;
        let ry2 = ry1;
        let rz2 = rx1 * (-this.sinB) + rz1 * this.cosB;
        let rx3 = rx2 * this.cosC + ry2 * (-this.sinC);
        let ry3 = rx2 * this.sinC + ry2 * this.cosC;
        let rz3 = rz2;
        this.tagAttrList[j].cx = rx3;
        this.tagAttrList[j].cy = ry3;
        this.tagAttrList[j].cz = rz3;
        let per = 350 / (350 + rz3);
        this.tagAttrList[j].x = rx3 * per - 2;
        this.tagAttrList[j].y = ry3 * per;
        this.tagAttrList[j].scale = per;
        this.tagAttrList[j].alpha = per;
        this.tagAttrList[j].alpha = (this.tagAttrList[j].alpha - 0.6) * (10 / 6);
      }
      this.doPositionindustry();
      this.depthSortindustry();
    },
    doPositionindustry () {
      let len = this.cloudContent.offsetWidth / 2;
      let height = this.cloudContent.offsetHeight / 2;
      for (let i = 0; i < this.tagAttrList.length; i++) {
        this.tagContent[i].style.left = this.tagAttrList[i].cx + len - this.tagAttrList[i].offsetWidth / 2 + 'px';
        this.tagContent[i].style.top = this.tagAttrList[i].cy + height - this.tagAttrList[i].offsetHeight / 2 + 'px';
        this.tagContent[i].style.fontSize = Math.ceil(12 * this.tagAttrList[i].scale / 2) + 2 + 'px';
        this.tagContent[i].style.filter = "alpha(opacity=" + 100 * this.tagAttrList[i].alpha + ")";
        this.tagContent[i].style.opacity = this.tagAttrList[i].alpha;
      }
    },
    depthSortindustry () {
      let aTmp = [];
      for (let i = 0; i < this.tagContent.length; i++) {
        aTmp.push(this.tagContent[i]);
      }
      aTmp.sort((item1, item2) => item2.cz - item1.cz);
      for (let i = 0; i < aTmp.length; i++) {
        aTmp[i].style.zIndex = i;
      }
    },


    getDatamarket (item) {
      if (this.SModelExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete).length == 0) {
        if (this.targetSelectedList.filter(c => c == item.id).length == 0) {
          this.targetSelectedList.push(item.id);
          this.planForm.market += "," + item.name;
          this.planForm.marketIds += "," + item.id;
          if (this.targetSelectedList.length == 1) {
            this.planForm.market = this.planForm.market.substring(1, this.planForm.market.length);
            this.planForm.marketIds = this.planForm.marketIds.substring(1, this.planForm.marketIds.length);
          }
        } else {
          this.targetSelectedList = this.targetSelectedList.filter(c => c !== item.id);
          this.planForm.market = this.planForm.market.split(',').filter(c => c != item.name).join(',');
          this.planForm.marketIds = this.planForm.marketIds.split(',').filter(c => c != item.id).join(',');
        }
      }
    },
    initWordCloudmarket () {
      this.cloudContent1 = document.querySelector('.cloud-box2');
      this.tagContent1 = this.cloudContent1.getElementsByTagName('span');
      for (let i = 0; i < this.tagContent1.length; i++) {
        let tagObj = {};
        tagObj.offsetWidth = this.tagContent1[i].offsetWidth;
        tagObj.offsetHeight = this.tagContent1[i].offsetHeight;
        this.tagAttrList1.push(tagObj);
      }
      this.sineCosine(0, 0, 0);
      this.positionAllmarket();
      this.cloudContent1.onmouseover = () => {
        this.active1 = true;
      };
      this.cloudContent1.onmouseout = () => {
        this.active1 = false;
      };
      this.cloudContent1.onmousemove = (ev) => {
        let oEvent = window.event || ev;
        this.mouseX = oEvent.clientX - (this.cloudContent1.offsetLeft + this.cloudContent1.offsetWidth / 2);
        this.mouseY = oEvent.clientY - (this.cloudContent1.offsetTop + this.cloudContent1.offsetHeight / 2);
        this.mouseX /= 5;
        this.mouseY /= 5;
      };
      setInterval(this.updatemarket, this.timer);
    },
    positionAllmarket () {
      let phi = 0;
      let theta = 0;
      let max = this.tagAttrList1.length;
      let aTmp = [];
      let oFragment = document.createDocumentFragment();
      //随机排序
      for (let i = 0; i < this.tagContent1.length; i++) {
        aTmp.push(this.tagContent1[i]);
      }
      aTmp.sort(() => {
        return Math.random() < 0.5 ? 1 : -1;
      });
      for (let i = 0; i < aTmp.length; i++) {
        oFragment.appendChild(aTmp[i]);
      }
      this.cloudContent1.appendChild(oFragment);
      for (let i = 1; i < max + 1; i++) {
        if (this.distr) {
          phi = Math.acos(-1 + (2 * i - 1) / max);
          theta = Math.sqrt(max * Math.PI) * phi;
        } else {
          phi = Math.random() * (Math.PI);
          theta = Math.random() * (2 * Math.PI);
        }
        //坐标变换
        this.tagAttrList1[i - 1].cx = this.radius1 * Math.cos(theta) * Math.sin(phi);
        this.tagAttrList1[i - 1].cy = this.radius1 * Math.sin(theta) * Math.sin(phi);
        this.tagAttrList1[i - 1].cz = this.radius1 * Math.cos(phi);
        this.tagContent1[i - 1].style.left = this.tagAttrList1[i - 1].cx + this.cloudContent1.offsetWidth / 2 - this.tagAttrList1[i - 1].offsetWidth / 2 + 'px';
        this.tagContent1[i - 1].style.top = this.tagAttrList1[i - 1].cy + this.cloudContent1.offsetHeight / 2 - this.tagAttrList1[i - 1].offsetHeight / 2 + 'px';
      }
    },
    updatemarket () {
      let angleBasicA;
      let angleBasicB;
      if (this.active1) {
        angleBasicA = (-Math.min(Math.max(-this.mouseY, -200), 200) / this.radius1) * this.tspeed;
        angleBasicB = (Math.min(Math.max(-this.mouseX, -200), 200) / this.radius1) * this.tspeed;
      } else {
        angleBasicA = this.lasta * 0.98;
        angleBasicB = this.lastb * 0.98;
      }
      this.sineCosine(angleBasicA, angleBasicB, 0);
      for (let j = 0; j < this.tagAttrList1.length; j++) {
        let rx1 = this.tagAttrList1[j].cx;
        let ry1 = this.tagAttrList1[j].cy * this.cosA + this.tagAttrList1[j].cz * (-this.sinA);
        let rz1 = this.tagAttrList1[j].cy * this.sinA + this.tagAttrList1[j].cz * this.cosA;
        let rx2 = rx1 * this.cosB + rz1 * this.sinB;
        let ry2 = ry1;
        let rz2 = rx1 * (-this.sinB) + rz1 * this.cosB;
        let rx3 = rx2 * this.cosC + ry2 * (-this.sinC);
        let ry3 = rx2 * this.sinC + ry2 * this.cosC;
        let rz3 = rz2;
        this.tagAttrList1[j].cx = rx3;
        this.tagAttrList1[j].cy = ry3;
        this.tagAttrList1[j].cz = rz3;
        let per = 350 / (350 + rz3);
        this.tagAttrList1[j].x = rx3 * per - 2;
        this.tagAttrList1[j].y = ry3 * per;
        this.tagAttrList1[j].scale = per;
        this.tagAttrList1[j].alpha = per;
        this.tagAttrList1[j].alpha = (this.tagAttrList1[j].alpha - 0.6) * (10 / 6);
      }
      this.doPositionmarket();
      this.depthSortmarket();
    },
    doPositionmarket () {
      let len = this.cloudContent1.offsetWidth / 2;
      let height = this.cloudContent1.offsetHeight / 2;
      for (let i = 0; i < this.tagAttrList1.length; i++) {
        this.tagContent1[i].style.left = this.tagAttrList1[i].cx + len - this.tagAttrList1[i].offsetWidth / 2 + 'px';
        this.tagContent1[i].style.top = this.tagAttrList1[i].cy + height - this.tagAttrList1[i].offsetHeight / 2 + 'px';
        this.tagContent1[i].style.fontSize = Math.ceil(12 * this.tagAttrList1[i].scale / 2) + 2 + 'px';
        this.tagContent1[i].style.filter = "alpha(opacity=" + 100 * this.tagAttrList1[i].alpha + ")";
        this.tagContent1[i].style.opacity = this.tagAttrList1[i].alpha;
      }
    },
    depthSortmarket () {
      let aTmp = [];
      for (let i = 0; i < this.tagContent1.length; i++) {
        aTmp.push(this.tagContent1[i]);
      }
      aTmp.sort((item1, item2) => item2.cz - item1.cz);
      for (let i = 0; i < aTmp.length; i++) {
        aTmp[i].style.zIndex = i;
      }
    },

    getDatasite (item) {
      if (this.SModelExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete).length == 0) {
        this.venueSelectedList = item.id;
        this.planForm.site = item.name;
        this.planForm.siteId = item.id;
        this.SiteArea = item.size;
      }
    },
    initWordCloudsite () {
      this.cloudContent2 = document.querySelector('.cloud-box3');
      this.tagContent2 = this.cloudContent2.getElementsByTagName('span');
      for (let i = 0; i < this.tagContent2.length; i++) {
        let tagObj = {};
        tagObj.offsetWidth = this.tagContent2[i].offsetWidth;
        tagObj.offsetHeight = this.tagContent2[i].offsetHeight;
        this.tagAttrList2.push(tagObj);
      }
      this.sineCosine(0, 0, 0);
      this.positionAllsite();
      this.cloudContent2.onmouseover = () => {
        this.active2 = true;
      };
      this.cloudContent2.onmouseout = () => {
        this.active2 = false;
      };
      this.cloudContent2.onmousemove = (ev) => {
        let oEvent = window.event || ev;
        this.mouseX = oEvent.clientX - (this.cloudContent2.offsetLeft + this.cloudContent2.offsetWidth / 2);
        this.mouseY = oEvent.clientY - (this.cloudContent2.offsetTop + this.cloudContent2.offsetHeight / 2);
        this.mouseX /= 5;
        this.mouseY /= 5;
      };
      this.timer2 = setInterval(this.updatesite, this.timer);
    },
    positionAllsite () {
      let phi = 0;
      let theta = 0;
      let max = this.tagAttrList2.length;
      let aTmp = [];
      let oFragment = document.createDocumentFragment();
      //随机排序
      for (let i = 0; i < this.tagContent2.length; i++) {
        aTmp.push(this.tagContent2[i]);
      }
      aTmp.sort(() => {
        return Math.random() < 0.5 ? 1 : -1;
      });
      for (let i = 0; i < aTmp.length; i++) {
        oFragment.appendChild(aTmp[i]);
      }
      this.cloudContent2.appendChild(oFragment);
      for (let i = 1; i < max + 1; i++) {
        if (this.distr) {
          phi = Math.acos(-1 + (2 * i - 1) / max);
          theta = Math.sqrt(max * Math.PI) * phi;
        } else {
          phi = Math.random() * (Math.PI);
          theta = Math.random() * (2 * Math.PI);
        }
        //坐标变换
        this.tagAttrList2[i - 1].cx = this.radius2 * Math.cos(theta) * Math.sin(phi);
        this.tagAttrList2[i - 1].cy = this.radius2 * Math.sin(theta) * Math.sin(phi);
        this.tagAttrList2[i - 1].cz = this.radius2 * Math.cos(phi);
        this.tagContent2[i - 1].style.left = this.tagAttrList2[i - 1].cx + this.cloudContent2.offsetWidth / 2 - this.tagAttrList2[i - 1].offsetWidth / 2 + 'px';
        this.tagContent2[i - 1].style.top = this.tagAttrList2[i - 1].cy + this.cloudContent2.offsetHeight / 2 - this.tagAttrList2[i - 1].offsetHeight / 2 + 'px';
      }
    },
    updatesite () {
      let angleBasicA;
      let angleBasicB;
      if (this.active2) {
        angleBasicA = (-Math.min(Math.max(-this.mouseY, -200), 200) / this.radius2) * this.tspeed;
        angleBasicB = (Math.min(Math.max(-this.mouseX, -200), 200) / this.radius2) * this.tspeed;
      } else {
        angleBasicA = this.lasta * 0.98;
        angleBasicB = this.lastb * 0.98;
      }
      this.sineCosine(angleBasicA, angleBasicB, 0);
      for (let j = 0; j < this.tagAttrList2.length; j++) {
        let rx1 = this.tagAttrList2[j].cx;
        let ry1 = this.tagAttrList2[j].cy * this.cosA + this.tagAttrList2[j].cz * (-this.sinA);
        let rz1 = this.tagAttrList2[j].cy * this.sinA + this.tagAttrList2[j].cz * this.cosA;
        let rx2 = rx1 * this.cosB + rz1 * this.sinB;
        let ry2 = ry1;
        let rz2 = rx1 * (-this.sinB) + rz1 * this.cosB;
        let rx3 = rx2 * this.cosC + ry2 * (-this.sinC);
        let ry3 = rx2 * this.sinC + ry2 * this.cosC;
        let rz3 = rz2;
        this.tagAttrList2[j].cx = rx3;
        this.tagAttrList2[j].cy = ry3;
        this.tagAttrList2[j].cz = rz3;
        let per = 350 / (350 + rz3);
        this.tagAttrList2[j].x = rx3 * per - 2;
        this.tagAttrList2[j].y = ry3 * per;
        this.tagAttrList2[j].scale = per;
        this.tagAttrList2[j].alpha = per;
        this.tagAttrList2[j].alpha = (this.tagAttrList2[j].alpha - 0.6) * (10 / 6);
      }
      this.doPositionsite();
      this.depthSortsite();
    },
    doPositionsite () {
      let len = this.cloudContent2.offsetWidth / 2;
      let height = this.cloudContent2.offsetHeight / 2;
      for (let i = 0; i < this.tagAttrList2.length; i++) {
        this.tagContent2[i].style.left = this.tagAttrList2[i].cx + len - this.tagAttrList2[i].offsetWidth / 2 + 'px';
        this.tagContent2[i].style.top = this.tagAttrList2[i].cy + height - this.tagAttrList2[i].offsetHeight / 2 + 'px';
        this.tagContent2[i].style.fontSize = Math.ceil(12 * this.tagAttrList2[i].scale / 2) + 2 + 'px';
        this.tagContent2[i].style.filter = "alpha(opacity=" + 100 * this.tagAttrList2[i].alpha + ")";
        this.tagContent2[i].style.opacity = this.tagAttrList2[i].alpha;
      }
    },
    depthSortsite () {
      let aTmp = [];
      for (let i = 0; i < this.tagContent2.length; i++) {
        aTmp.push(this.tagContent2[i]);
      }
      aTmp.sort((item1, item2) => item2.cz - item1.cz);
      for (let i = 0; i < aTmp.length; i++) {
        aTmp[i].style.zIndex = i;
      }
    },
    getDatademand (item) {

      if (this.SModelExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete).length == 0) {
        if (this.demandSelectedList.filter(c => c == item.id).length == 0) {
          this.demandSelectedList.push(item.id);
          this.planForm.demand += "," + item.name;
          this.planForm.demandId += "," + item.id;
          if (this.demandSelectedList.length == 1) {
            this.planForm.demand = this.planForm.demand.substring(1, this.planForm.demand.length);
            this.planForm.demandId = this.planForm.demandId.substring(1, this.planForm.demandId.length);
          }
        } else {
          this.demandSelectedList = this.demandSelectedList.filter(c => c !== item.id);
          this.planForm.demand = this.planForm.demand.split(',').filter(c => c != item.name).join(',');
          this.planForm.demandId = this.planForm.demandId.split(',').filter(c => c != item.id).join(',');
        }
      }
    },
    initWordClouddemand () {
      this.cloudContent3 = document.querySelector('.cloud-box4');
      this.tagContent3 = this.cloudContent3.getElementsByTagName('span');
      for (let i = 0; i < this.tagContent3.length; i++) {
        let tagObj = {};
        tagObj.offsetWidth = this.tagContent3[i].offsetWidth;
        tagObj.offsetHeight = this.tagContent3[i].offsetHeight;
        this.tagAttrList3.push(tagObj);
      }
      this.sineCosine(0, 0, 0);
      this.positionAlldemand();
      this.cloudContent3.onmouseover = () => {
        this.active3 = true;
      };
      this.cloudContent3.onmouseout = () => {
        this.active3 = false;
      };
      this.cloudContent3.onmousemove = (ev) => {
        let oEvent = window.event || ev;
        this.mouseX = oEvent.clientX - (this.cloudContent3.offsetLeft + this.cloudContent3.offsetWidth / 2);
        this.mouseY = oEvent.clientY - (this.cloudContent3.offsetTop + this.cloudContent3.offsetHeight / 2);
        this.mouseX /= 5;
        this.mouseY /= 5;
      };
      setInterval(this.updatedemand, this.timer);
    },
    positionAlldemand () {
      let phi = 0;
      let theta = 0;
      let max = this.tagAttrList3.length;
      let aTmp = [];
      let oFragment = document.createDocumentFragment();
      //随机排序
      for (let i = 0; i < this.tagContent3.length; i++) {
        aTmp.push(this.tagContent3[i]);
      }
      aTmp.sort(() => {
        return Math.random() < 0.5 ? 1 : -1;
      });
      for (let i = 0; i < aTmp.length; i++) {
        oFragment.appendChild(aTmp[i]);
      }
      this.cloudContent3.appendChild(oFragment);
      for (let i = 1; i < max + 1; i++) {
        if (this.distr) {
          phi = Math.acos(-1 + (2 * i - 1) / max);
          theta = Math.sqrt(max * Math.PI) * phi;
        } else {
          phi = Math.random() * (Math.PI);
          theta = Math.random() * (2 * Math.PI);
        }
        //坐标变换
        this.tagAttrList3[i - 1].cx = this.radius3 * Math.cos(theta) * Math.sin(phi);
        this.tagAttrList3[i - 1].cy = this.radius3 * Math.sin(theta) * Math.sin(phi);
        this.tagAttrList3[i - 1].cz = this.radius3 * Math.cos(phi);
        this.tagContent3[i - 1].style.left = this.tagAttrList3[i - 1].cx + this.cloudContent3.offsetWidth / 2 - this.tagAttrList3[i - 1].offsetWidth / 2 + 'px';
        this.tagContent3[i - 1].style.top = this.tagAttrList3[i - 1].cy + this.cloudContent3.offsetHeight / 2 - this.tagAttrList3[i - 1].offsetHeight / 2 + 'px';
      }
    },
    updatedemand () {
      let angleBasicA;
      let angleBasicB;
      if (this.active3) {
        angleBasicA = (-Math.min(Math.max(-this.mouseY, -200), 200) / this.radius3) * this.tspeed;
        angleBasicB = (Math.min(Math.max(-this.mouseX, -200), 200) / this.radius3) * this.tspeed;
      } else {
        angleBasicA = this.lasta * 0.98;
        angleBasicB = this.lastb * 0.98;
      }
      this.sineCosine(angleBasicA, angleBasicB, 0);
      for (let j = 0; j < this.tagAttrList3.length; j++) {
        let rx1 = this.tagAttrList3[j].cx;
        let ry1 = this.tagAttrList3[j].cy * this.cosA + this.tagAttrList3[j].cz * (-this.sinA);
        let rz1 = this.tagAttrList3[j].cy * this.sinA + this.tagAttrList3[j].cz * this.cosA;
        let rx2 = rx1 * this.cosB + rz1 * this.sinB;
        let ry2 = ry1;
        let rz2 = rx1 * (-this.sinB) + rz1 * this.cosB;
        let rx3 = rx2 * this.cosC + ry2 * (-this.sinC);
        let ry3 = rx2 * this.sinC + ry2 * this.cosC;
        let rz3 = rz2;
        this.tagAttrList3[j].cx = rx3;
        this.tagAttrList3[j].cy = ry3;
        this.tagAttrList3[j].cz = rz3;
        let per = 350 / (350 + rz3);
        this.tagAttrList3[j].x = rx3 * per - 2;
        this.tagAttrList3[j].y = ry3 * per;
        this.tagAttrList3[j].scale = per;
        this.tagAttrList3[j].alpha = per;
        this.tagAttrList3[j].alpha = (this.tagAttrList3[j].alpha - 0.6) * (10 / 6);
      }
      this.doPositiondemand();
      this.depthSortdemand();
    },
    doPositiondemand () {
      let len = this.cloudContent3.offsetWidth / 2;
      let height = this.cloudContent3.offsetHeight / 2;
      for (let i = 0; i < this.tagAttrList3.length; i++) {
        this.tagContent3[i].style.left = this.tagAttrList3[i].cx + len - this.tagAttrList3[i].offsetWidth / 2 + 'px';
        this.tagContent3[i].style.top = this.tagAttrList3[i].cy + height - this.tagAttrList3[i].offsetHeight / 2 + 'px';
        this.tagContent3[i].style.fontSize = Math.ceil(12 * this.tagAttrList3[i].scale / 2) + 2 + 'px';
        this.tagContent3[i].style.filter = "alpha(opacity=" + 100 * this.tagAttrList3[i].alpha + ")";
        this.tagContent3[i].style.opacity = this.tagAttrList3[i].alpha;
      }
    },
    depthSortdemand () {
      let aTmp = [];
      for (let i = 0; i < this.tagContent3.length; i++) {
        aTmp.push(this.tagContent3[i]);
      }
      aTmp.sort((item1, item2) => item2.cz - item1.cz);
      for (let i = 0; i < aTmp.length; i++) {
        aTmp[i].style.zIndex = i;
      }
    },

    sineCosine (a, b, c) {
      this.sinA = Math.sin(a * this.dtr);
      this.cosA = Math.cos(a * this.dtr);
      this.sinB = Math.sin(b * this.dtr);
      this.cosB = Math.cos(b * this.dtr);
      this.sinC = Math.sin(c * this.dtr);
      this.cosC = Math.cos(c * this.dtr);
    },
  },
};
</script>

<style scoped>
.box {
  height: 100%;
  width: 33.3%;
  float: left;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.box10 {
  height: 100%;
}
.exhibitionbox {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 15%;
}
.exhibitionbox1 {
  width: 100%;

}
.inputs {
  width: 80%;
  float: left;
}
.chart-container {
  margin-top: 10px;
  height: 200px;
}

.cloud-bed {
  width: 200px;
  height: 200px;
  margin: auto;
}
.cloud-bed div {
  position: relative;
  margin: 20px auto 0px;
  width: 100%;
  height: 100%;
  background: #00000000;
}
.cloud-bed span {
  position: absolute;
  padding: 3px 6px;
  top: 0px;
  font-weight: bold;
  text-decoration: none;
  left: 0px;
  background-image: linear-gradient(to bottom, red, #fff);
  background-clip: text;
  color: transparent;
  width: 60px;
  height: 50px;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.activetext {
  color: #fbae22;
}
</style>